import React, { useEffect, useState } from "react";
import Crypto from "../operationsIcons/crypto";
import {
  EmailIcon,
  EmailShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  ViberIcon,
  ViberShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";
import { useSearchParams } from "react-router-dom";
export default function LoadingConnect({ selectedContract }) {
  const [searchParams] = useSearchParams();
  const co = searchParams.get("co");
  const [loadingBalance, setLoadingBalance] = useState(false);
  const [open, setOpen] = useState(false);
  let [currentBalance, setBalance] = useState(false);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [percent, setPercent] = useState(0);
  useEffect(() => {
    if (document.getElementById("loading_fill2")) {
      document.getElementById("loading_fill2").style.width = `${percent}%`;
    }
  }, [percent]);
  useEffect(() => {
    if (percent < 100) {
      const interval = setInterval(() => setPercent(percent + 1), 10);
      return () => clearInterval(interval);
    } else {
      setPercent(0);
    }
  }, [percent]);

  return (
    <div className={"w-full p-10 bg-[#F8FEFF] h-dvh no-scrollbar"}>
      <div className="w-full flex flex-col items-center justify-between h-full">
        {!co && (
          <div className="flex flex-col justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="120.422"
              height="20.02"
              viewBox="0 0 120.422 20.02"
              className="mb-[25px]"
            >
              <g
                id="Group_11945"
                data-name="Group 11945"
                transform="translate(-154.66 -46.38)"
              >
                <path
                  id="Path_21886"
                  data-name="Path 21886"
                  d="M12.892-15.444a1.391,1.391,0,0,1,.957.363,1.171,1.171,0,0,1,.407.913,1.505,1.505,0,0,1-.132.594L8.69-.858a1.366,1.366,0,0,1-.561.649A1.462,1.462,0,0,1,7.392,0,1.43,1.43,0,0,1,6.71-.231a1.335,1.335,0,0,1-.506-.6L.77-13.6a.927.927,0,0,1-.088-.275,1.809,1.809,0,0,1-.022-.275,1.143,1.143,0,0,1,.462-.979A1.5,1.5,0,0,1,2-15.466a1.257,1.257,0,0,1,1.21.858L8.03-3.278l-.77.022,4.422-11.352A1.256,1.256,0,0,1,12.892-15.444Zm6.974,14.1a1.248,1.248,0,0,1-.418.957A1.385,1.385,0,0,1,18.48,0a1.317,1.317,0,0,1-.99-.385,1.319,1.319,0,0,1-.374-.957V-14.058a1.281,1.281,0,0,1,.4-.957,1.392,1.392,0,0,1,1.012-.385,1.321,1.321,0,0,1,.935.385,1.264,1.264,0,0,1,.407.957ZM28.666.22a9.277,9.277,0,0,1-2.772-.385A6.641,6.641,0,0,1,23.54-1.518a1.736,1.736,0,0,1-.44-.55,1.367,1.367,0,0,1-.154-.616,1.26,1.26,0,0,1,.363-.891,1.2,1.2,0,0,1,.913-.385,1.165,1.165,0,0,1,.748.264,7,7,0,0,0,1.661,1.034,5.192,5.192,0,0,0,2.035.352,4.27,4.27,0,0,0,1.5-.253,2.93,2.93,0,0,0,1.1-.682,1.365,1.365,0,0,0,.418-.979,1.665,1.665,0,0,0-.4-1.122,3.007,3.007,0,0,0-1.21-.781,9.312,9.312,0,0,0-2.068-.495,9.231,9.231,0,0,1-2.09-.539,4.854,4.854,0,0,1-1.507-.924,3.653,3.653,0,0,1-.913-1.32,4.5,4.5,0,0,1-.308-1.7,4.035,4.035,0,0,1,.737-2.442,4.616,4.616,0,0,1,1.991-1.54,7.074,7.074,0,0,1,2.772-.528,7.945,7.945,0,0,1,2.651.429A6.173,6.173,0,0,1,33.33-14.1a1.468,1.468,0,0,1,.638,1.166,1.253,1.253,0,0,1-.374.88,1.173,1.173,0,0,1-.88.4.965.965,0,0,1-.594-.2,3.973,3.973,0,0,0-.946-.583A8.485,8.485,0,0,0,29.92-12.9a4.534,4.534,0,0,0-1.232-.187,4.592,4.592,0,0,0-1.595.242,2.18,2.18,0,0,0-.979.66,1.518,1.518,0,0,0-.33.968,1.569,1.569,0,0,0,.385,1.089,2.614,2.614,0,0,0,1.111.682A12.835,12.835,0,0,0,29.018-9a17.617,17.617,0,0,1,2.321.572A5.428,5.428,0,0,1,33-7.579a3.207,3.207,0,0,1,.99,1.3,4.888,4.888,0,0,1,.33,1.9,3.934,3.934,0,0,1-.792,2.464A5.07,5.07,0,0,1,31.449-.33,7.007,7.007,0,0,1,28.666.22ZM40.15-1.342a1.248,1.248,0,0,1-.418.957A1.385,1.385,0,0,1,38.764,0a1.317,1.317,0,0,1-.99-.385,1.319,1.319,0,0,1-.374-.957V-14.058a1.281,1.281,0,0,1,.4-.957,1.392,1.392,0,0,1,1.012-.385,1.321,1.321,0,0,1,.935.385,1.264,1.264,0,0,1,.407.957ZM58.168-7.7a8.507,8.507,0,0,1-.55,3.08A7.844,7.844,0,0,1,56.067-2.1,7.174,7.174,0,0,1,53.691-.4a7.261,7.261,0,0,1-3,.616A7.185,7.185,0,0,1,47.7-.4,7.206,7.206,0,0,1,45.331-2.1,7.844,7.844,0,0,1,43.78-4.62a8.507,8.507,0,0,1-.55-3.08,8.507,8.507,0,0,1,.55-3.08A7.844,7.844,0,0,1,45.331-13.3,7.206,7.206,0,0,1,47.7-15a7.185,7.185,0,0,1,2.992-.616,7.261,7.261,0,0,1,3,.616,7.174,7.174,0,0,1,2.376,1.7,7.844,7.844,0,0,1,1.551,2.519A8.507,8.507,0,0,1,58.168-7.7Zm-2.86,0a5.938,5.938,0,0,0-.594-2.673,4.86,4.86,0,0,0-1.628-1.9,4.158,4.158,0,0,0-2.4-.7,4.158,4.158,0,0,0-2.4.7,4.793,4.793,0,0,0-1.617,1.892A6.012,6.012,0,0,0,46.09-7.7a6.032,6.032,0,0,0,.583,2.673,4.776,4.776,0,0,0,1.617,1.9,4.158,4.158,0,0,0,2.4.7,4.158,4.158,0,0,0,2.4-.7,4.86,4.86,0,0,0,1.628-1.9A5.938,5.938,0,0,0,55.308-7.7ZM72.93-15.4a1.122,1.122,0,0,1,.858.352,1.237,1.237,0,0,1,.33.88V-1.342a1.3,1.3,0,0,1-.385.957A1.3,1.3,0,0,1,72.776,0a1.837,1.837,0,0,1-.583-.1,1.007,1.007,0,0,1-.451-.275L63.1-11.352l.572-.352V-1.232a1.214,1.214,0,0,1-.341.88A1.185,1.185,0,0,1,62.436,0a1.122,1.122,0,0,1-.858-.352,1.237,1.237,0,0,1-.33-.88V-14.058a1.3,1.3,0,0,1,.385-.957,1.3,1.3,0,0,1,.957-.385,1.849,1.849,0,0,1,.638.121.927.927,0,0,1,.484.363L72.094-4.224l-.374.264V-14.168a1.237,1.237,0,0,1,.33-.88A1.149,1.149,0,0,1,72.93-15.4Zm17.875,0a4.207,4.207,0,0,1,2.178.561,3.984,3.984,0,0,1,1.493,1.551,4.667,4.667,0,0,1,.542,2.277,4.812,4.812,0,0,1-.542,2.288A4.185,4.185,0,0,1,92.983-7.1a4.013,4.013,0,0,1-2.178.6H86.13l.121-.215V-.665a.641.641,0,0,1-.2.47.641.641,0,0,1-.47.2A.621.621,0,0,1,85.1-.2a.672.672,0,0,1-.179-.47V-14.734a.641.641,0,0,1,.2-.47.641.641,0,0,1,.47-.2Zm0,7.606a2.626,2.626,0,0,0,1.5-.426,2.927,2.927,0,0,0,1-1.16,3.629,3.629,0,0,0,.363-1.631A3.408,3.408,0,0,0,93.3-12.62a2.794,2.794,0,0,0-1-1.089,2.76,2.76,0,0,0-1.5-.4h-4.67l.116-.182v6.633l-.127-.138Zm16.566-3.437a.629.629,0,0,1,.476.193.658.658,0,0,1,.184.473v9.9a.646.646,0,0,1-.193.47.632.632,0,0,1-.467.2.625.625,0,0,1-.476-.2.661.661,0,0,1-.184-.47V-3.278l.385-.165a2.667,2.667,0,0,1-.341,1.246,4.407,4.407,0,0,1-.935,1.191,4.844,4.844,0,0,1-1.4.886A4.42,4.42,0,0,1,102.68.22a4.729,4.729,0,0,1-2.659-.773,5.354,5.354,0,0,1-1.848-2.107A6.6,6.6,0,0,1,97.5-5.676a6.43,6.43,0,0,1,.682-3.014,5.285,5.285,0,0,1,1.851-2.057,4.768,4.768,0,0,1,2.626-.748,4.759,4.759,0,0,1,1.771.327,4.571,4.571,0,0,1,1.441.9,4.214,4.214,0,0,1,.96,1.3,3.566,3.566,0,0,1,.344,1.535l-.462-.341v-2.794a.661.661,0,0,1,.184-.47A.625.625,0,0,1,107.371-11.231ZM102.795-1.012a3.64,3.64,0,0,0,2.074-.608,4.126,4.126,0,0,0,1.422-1.667,5.4,5.4,0,0,0,.514-2.39,5.192,5.192,0,0,0-.514-2.329,4.15,4.15,0,0,0-1.422-1.65,3.64,3.64,0,0,0-2.074-.608,3.675,3.675,0,0,0-2.051.591,4.1,4.1,0,0,0-1.43,1.625,5.185,5.185,0,0,0-.522,2.371,5.4,5.4,0,0,0,.514,2.39,4.126,4.126,0,0,0,1.422,1.667A3.631,3.631,0,0,0,102.795-1.012ZM120.423-11.44a.625.625,0,0,1,.476.2.661.661,0,0,1,.184.47v9.7a5.949,5.949,0,0,1-.7,3,4.646,4.646,0,0,1-1.895,1.851,5.742,5.742,0,0,1-2.711.627,6.852,6.852,0,0,1-1.735-.209,4.671,4.671,0,0,1-1.306-.528,1.028,1.028,0,0,1-.41-.377.512.512,0,0,1-.025-.476.692.692,0,0,1,.349-.4.5.5,0,0,1,.47.019q.368.192,1.081.481a4.25,4.25,0,0,0,1.609.289,4.1,4.1,0,0,0,2.1-.514,3.5,3.5,0,0,0,1.375-1.469,4.926,4.926,0,0,0,.49-2.274V-2.645l.148.544a3.648,3.648,0,0,1-.935,1.2,4.733,4.733,0,0,1-1.389.822,4.558,4.558,0,0,1-1.653.3,4.075,4.075,0,0,1-2.184-.539,3.3,3.3,0,0,1-1.3-1.488,5.359,5.359,0,0,1-.426-2.214v-6.754a.661.661,0,0,1,.184-.47.625.625,0,0,1,.476-.2.625.625,0,0,1,.476.2.661.661,0,0,1,.184.47v6.556a3.682,3.682,0,0,0,.677,2.368,2.657,2.657,0,0,0,2.194.839,3.509,3.509,0,0,0,1.735-.446,3.744,3.744,0,0,0,1.3-1.185,2.763,2.763,0,0,0,.5-1.576v-6.556a.661.661,0,0,1,.184-.47A.625.625,0,0,1,120.423-11.44Z"
                  transform="translate(154 62)"
                  fill="#404040"
                />
              </g>
            </svg>
            <div className="w-[410px] min-h-[40px] flex flex-row items-center justify-center mb-[80px] rounded-[15px] bg-[#F0F0F0]">
              <div className="ml-[20px] flex items-center justify-center w-[20px] h-[20px]">
                <Crypto color="#404040" />
              </div>
              <div className="text-[#404040] w-full text-center family-reg">
                Deposit Crypto
              </div>
              <div className="ml-[20px] flex items-center justify-center w-[20px] h-[20px]"></div>
            </div>
            <div
              className={
                " flex flex-col rounded-[15px] mb-[80px] relative select-none"
              }
            >
              <div className="flex flex-row items-center bg-[#FAFAFA] w-[350px] h-[50px] rounded-[15px] justify-between">
                <div className="w-[30px] h-[30px] ml-[10px] flex items-center justify-center"></div>
                <div
                  className={`w-full flex justify-center items-center text-[#8E8E8E] text-[16px] text-nowrap whitespace-nowrap overflow-hidden family-reg`}
                ></div>
                <div className="w-[15px] h-[15px] mr-[15px] cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                  >
                    <g
                      id="Group_11952"
                      data-name="Group 11952"
                      transform="translate(-343 -399)"
                    >
                      <g
                        id="Group_11951"
                        data-name="Group 11951"
                        transform="translate(341.5 397.5)"
                      >
                        <path
                          id="Path_21911"
                          data-name="Path 21911"
                          d="M11.43,1.5H8.509a26.2,26.2,0,0,0-3.191.111,3.385,3.385,0,0,0-2.066.9A3.412,3.412,0,0,0,2.36,4.58a26.512,26.512,0,0,0-.11,3.2v4.378A2.712,2.712,0,0,0,3.92,14.67c-.05-.682-.05-1.639-.05-2.435V8.477a20.019,20.019,0,0,1,.089-2.453,3.228,3.228,0,0,1,.86-1.945,3.2,3.2,0,0,1,1.937-.864A19.782,19.782,0,0,1,9.2,3.127h2.3a19.751,19.751,0,0,1,2.441.089A2.7,2.7,0,0,0,11.43,1.5Z"
                          fill="#cecdcd"
                        />
                        <path
                          id="Path_21912"
                          data-name="Path 21912"
                          d="M4.95,8.548c0-2.045,0-3.067.633-3.7s1.651-.635,3.687-.635h2.16c2.036,0,3.055,0,3.687.635s.633,1.658.633,3.7v3.615c0,2.045,0,3.067-.633,3.7s-1.651.635-3.687.635H9.27c-2.036,0-3.055,0-3.687-.635s-.633-1.658-.633-3.7Z"
                          fill="#cecdcd"
                        />
                      </g>
                      <rect
                        id="Rectangle_5486"
                        data-name="Rectangle 5486"
                        width="15"
                        height="15"
                        transform="translate(343 399)"
                        fill="none"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col items-center justify-center">
              <div className="text-[#8E8E8E] text-[16px] mb-[15px] family-light">
                Transaction Amount
              </div>
              <div className="w-full flex flex-row items-center justify-center">
                <div
                  className={`w-[170px] flex flex-row justify-center items-center h-[15px] animate-fade-in ml-[10px]`}
                >
                  <div className="w-[12px] h-[12px] mr-[5px]"></div>
                  <div className="text-[10px] text-[#CECDCD] family-reg"></div>
                </div>
                <div className="family-med text-[#5D5D5D] text-[40px] bg-[#F8FEFF] w-fit text-center">
                  0
                </div>
                <div
                  className={`min-w-[170px] flex flex-row justify-center items-center animate-fade-in ml-[10px] h-[15px]`}
                >
                  <div className="w-[12px] h-[12px] mr-[5px]"></div>
                  <div className="text-[10px] text-[#CECDCD] family-reg"></div>
                </div>
              </div>
            </div>
          </div>
        )}
        {openShareModal && (
          <div
            className="fixed bg-white border border-[#FAFAFA] shadow-sm w-[300px] h-[50px] z-20 rounded-[15px] animate-fade-in flex items-center justify-center"
            style={{
              top: `${
                document.getElementById("share-button").getBoundingClientRect()
                  .top - 60
              }px`,
              left: `${
                document.getElementById("share-button").getBoundingClientRect()
                  .left - 140
              }px`,
            }}
          >
            <div className="Demo__some-network flex flex-row gap-2">
              <WhatsappShareButton
                title="Ramaaz Pay"
                url={`${process.env.REACT_APP_REDIRECT_URL}`}
                className="Demo__some-network__share-button"
              >
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
              <EmailShareButton
                title="Ramaaz Pay"
                url={`${process.env.REACT_APP_REDIRECT_URL}`}
                className="Demo__some-network__share-button"
              >
                <EmailIcon size={32} round />
              </EmailShareButton>
              <LinkedinShareButton
                title="Ramaaz Pay"
                url={`${process.env.REACT_APP_REDIRECT_URL}`}
                className="Demo__some-network__share-button"
              >
                <LinkedinIcon size={32} round />
              </LinkedinShareButton>
              <TelegramShareButton
                title="Ramaaz Pay"
                url={`${process.env.REACT_APP_REDIRECT_URL}`}
                className="Demo__some-network__share-button"
              >
                <TelegramIcon size={32} round />
              </TelegramShareButton>
              <TwitterShareButton
                title="Ramaaz Pay"
                url={`${process.env.REACT_APP_REDIRECT_URL}`}
                className="Demo__some-network__share-button"
              >
                <XIcon size={32} round />
              </TwitterShareButton>
              <ViberShareButton
                title="Ramaaz Pay"
                url={`${process.env.REACT_APP_REDIRECT_URL}`}
                className="Demo__some-network__share-button"
              >
                <ViberIcon size={32} round />
              </ViberShareButton>
            </div>
          </div>
        )}
        <div className="flex flex-col justify-center items-center">
          <div
            id="share-button"
            className="flex flex-row text-center items-center justify-center cursor-pointer w-[20px]"
            onClick={() => {
              setOpenShareModal(!openShareModal);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <g
                id="Group_11950"
                data-name="Group 11950"
                transform="translate(-218 -654)"
              >
                <g
                  id="Group_11949"
                  data-name="Group 11949"
                  transform="translate(217.297 653.482)"
                >
                  <path
                    id="Path_21913"
                    data-name="Path 21913"
                    d="M10.7,2.676v10.7m0-10.7L7.135,6.243M10.7,2.676,14.27,6.243"
                    fill="none"
                    stroke="#8c8c8c"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                  />
                  <path
                    id="Path_21914"
                    data-name="Path 21914"
                    d="M1.784,15.161l.554,2.216a1.784,1.784,0,0,0,1.73,1.351H17.336a1.784,1.784,0,0,0,1.73-1.351l.554-2.216"
                    fill="none"
                    stroke="#8c8c8c"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                  />
                </g>
                <rect
                  id="Rectangle_5487"
                  data-name="Rectangle 5487"
                  width="20"
                  height="20"
                  transform="translate(218 654)"
                  fill="none"
                />
              </g>
            </svg>
          </div>
          <div
            className={`mt-[60px] flex flex-col w-[350px] bg-[#FAFAFA] border border-[#DDDDDD] items-center justify-between rounded-[15px] relative`}
          >
            <div className="m-[10px] w-[325px] h-[30px] flex flex-row items-center justify-between">
              <div className="w-[30px] h-[30px] flex items-center justify-center"></div>
              <div className="w-full flex items-center justify-center h-[30px]"></div>
              <div className="w-[30px] h-[30px] flex items-center justify-center cursor-pointer">
                <svg
                  id="_15x15_photo_back"
                  data-name="15x15 photo back"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                >
                  <g id="Mask_Group_194" data-name="Mask Group 194">
                    <g id="dollar">
                      <g id="Group_7904" data-name="Group 7904">
                        <g id="Group_7903" data-name="Group 7903">
                          <path
                            id="Path_19173"
                            data-name="Path 19173"
                            d="M14.674,7.173a.326.326,0,0,0-.326.326c0,.237-.012.471-.035.7s-.059.458-.1.68a6.528,6.528,0,0,1-.168.656c-.067.214-.144.425-.23.629s-.183.4-.289.6-.219.382-.343.565-.255.358-.393.527-.287.331-.443.487-.318.3-.487.442-.344.271-.528.394-.371.237-.564.343-.394.2-.6.288-.415.164-.628.231-.434.123-.657.168-.45.08-.679.1a7.183,7.183,0,0,1-1.4,0c-.23-.024-.458-.059-.68-.1a6.529,6.529,0,0,1-.656-.168c-.214-.067-.425-.144-.629-.23s-.405-.183-.6-.288-.383-.22-.565-.344-.358-.255-.527-.393-.331-.287-.487-.443-.3-.318-.442-.487-.271-.344-.393-.527c-.053-.078-.1-.161-.147-.241H3.587a.326.326,0,1,0,0-.652H.978a.326.326,0,0,0-.326.326v2.609a.326.326,0,1,0,.652,0V11.724c.128.188.263.371.409.546s.314.363.483.532.347.331.532.484.378.3.577.431.406.26.619.376.431.22.656.316.453.179.689.252.475.134.719.185a7.52,7.52,0,0,0,.745.113A7.432,7.432,0,0,0,7.5,15c.258,0,.514-.014.768-.039s.5-.064.744-.113.483-.112.72-.185.464-.158.689-.253.443-.2.656-.316.419-.241.618-.375.393-.279.578-.432.363-.314.532-.483.331-.347.484-.532.3-.378.431-.577.26-.406.375-.618a7.254,7.254,0,0,0,.317-.657q.142-.336.252-.689t.185-.719a7.52,7.52,0,0,0,.113-.745c.025-.252.038-.507.038-.766A.326.326,0,0,0,14.674,7.173Z"
                            fill="#8e8e8e"
                          />
                          <path
                            id="Path_19174"
                            data-name="Path 19174"
                            d="M.687,6.8c.024-.23.059-.458.1-.68A6.529,6.529,0,0,1,.96,5.463c.067-.214.143-.425.23-.629s.183-.405.288-.6.22-.383.344-.565.255-.358.393-.527.287-.331.443-.487.318-.3.487-.442.345-.271.528-.394.371-.237.564-.343.395-.2.6-.288.415-.164.628-.23S5.9.837,6.12.791s.45-.08.679-.1a7.183,7.183,0,0,1,1.4,0c.23.024.458.059.68.1A6.529,6.529,0,0,1,9.536.96c.214.067.425.144.629.23s.405.183.6.288.383.22.565.344.358.255.527.393.331.287.487.443.3.318.442.487.271.344.394.528c.053.078.1.161.147.241H11.413a.326.326,0,1,0,0,.652h2.609a.326.326,0,0,0,.326-.326V1.63a.326.326,0,1,0-.652,0V3.275c-.128-.188-.263-.371-.409-.546s-.314-.363-.483-.532-.347-.331-.533-.485-.378-.3-.577-.431-.406-.26-.619-.376-.431-.22-.656-.316S9.965.41,9.729.337,9.254.2,9.01.152A7.52,7.52,0,0,0,8.265.039a7.728,7.728,0,0,0-1.534,0c-.252.025-.5.064-.744.113s-.482.112-.718.185S4.8.495,4.58.589s-.443.2-.656.316-.418.241-.618.376-.392.279-.577.432-.363.314-.533.483-.331.347-.484.533-.3.378-.431.577-.261.406-.376.62-.22.431-.316.655S.41,5.034.337,5.27.2,5.745.153,5.988a7.52,7.52,0,0,0-.113.745A7.609,7.609,0,0,0,0,7.5a.326.326,0,1,0,.652,0C.652,7.263.665,7.029.687,6.8Z"
                            fill="#8e8e8e"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <button
            disabled={true}
            className={`family-reg bg-[#3066CC] text-[#FAFAFA] text-[18px] mt-[5px] border disabled:cursor-not-allowed disabled:bg-[#8DB4FF] disabled:border-[#DDDDDD]   h-[50px] rounded-[10px] w-[350px]`}
          >
            connect wallet & pay
          </button>
          <div className="loading_percent rounded-[30px] w-[235px] h-[5px] flex flex-row items-start justify-start border border-[#707070] mt-[5px]">
            <div
              id="loading_fill2"
              className="bg-[#3066CC] rounded-[30px] h-full"
            />
          </div>
          <div
            className="family-light mt-[18px] w-full flex flex-row text-center items-center justify-center text-[16px] text-[#8E8E8E0] underline cursor-pointer"
            onClick={() => {}}
          >
            Cancel Transaction
          </div>
        </div>
      </div>
    </div>
  );
}
